import axios from 'axios';

export class UserService {
    
    constructor() {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('um-token')}`;
    }

    getUserById = async (id) => {
        return await axios.get('/api/user/users/' + id);
    };

    getUsers = async () => {
        return await axios.get('/api/user');
    };

    getFilteredUsers = async () => {
        return await axios.get('/api/user/filteredusers');
    };

    updateUser = async (user) => {
        return await axios.put('/api/user/updateuser', user);
    };

    getUserRequests = async () => {
        return await axios.get('/api/user/userrequests');
    };

    registrationAdmin = async (requestedUser) => {
        return await axios.put('/api/user/registrationadmin', requestedUser);
    };

    getprimaryapplicationbyuserId = async (userId) => {
        return await axios.get('/api/user/getprimaryapplicationnamebyuserId?userId=' + userId);
    };

    changePassword = async (vm) => {
        return await axios.post('/api/user/passwordadmin', vm);
    };
}
